export const THIRTY_DAYS_MS = 30 * 24 * 60 * 60 * 1000

// Matches the API default page size; keep in sync if the backend default changes.
export const FI_PAGE_SIZE = 50

export interface FICubes {
  sessions_created: number
  reports_completed: number
  active_consents_net: number
  pm_views: number
}

export interface FIRenter {
  id: number
  name: string
  email: string
}

export interface FIActor {
  id: number
  name: string
  is_manager: boolean
}

export interface FIApplication {
  id: string
  address: string
}

export interface FIActivityRow {
  id: string
  created_at: string
  activity_type: number
  action_label: string
  renter: FIRenter
  actor: FIActor
  application: FIApplication
}

export interface FIActivityResponse {
  cubes: FICubes
  activities: FIActivityRow[]
  pagination: { page: number; page_size: number; total: number }
}

// Fallback label map — the server also supplies action_label per row (authoritative).
// This is used only if a new activity type is rolled out before the frontend is updated.
export const activityTypeLabel: Record<number, string> = {
  47: 'Started financial insights bank connection',
  48: 'Completed financial insights report',
  49: 'Attached financial insights report to profile',
  50: 'Revoked financial insights consent',
  10021: 'Viewed financial insights report',
}
